import { useQuery } from "@tanstack/react-query";
import { mailbox } from "./api";
import { MAILBOX_SUMMARY_QUERY_KEY } from "./query-keys";

/** Canonical unread total shared by the shell navigation and Inbox. */
export function useMailUnreadCount(): number {
    const { data } = useQuery({
        queryKey: MAILBOX_SUMMARY_QUERY_KEY,
        queryFn: mailbox.summary,
        staleTime: 30_000,
    });
    return data?.inboxUnread ?? 0;
}
